<template lang="pug">
  .component-create-entity-button
    .row
      .columns
        label Document type
          SelectizeDocumentType(@optionSelected="documentTypeSelected", :max-items="1", :selected-value="localValue.document_type_id")
        label Document group
          input(type="text", v-model="localValue.document_group")
      .columns
        .row
          .columns
            label Maximum failed transactions
              .row
                .column
                  input(type="text", v-model="localValue.maximum_client_failed_transactions" placeholder="Transactions count (count|days 10|30)", pattern="[0-9]+\\|[0-9]+")
            label Driver bookings in last days
              .row
                .column
                  input(type="text", v-model="localValue.minimum_bookings_in_last_days" placeholder="Reservation count (eg. count|days 10|30)")
            .row
              .column
                label Driver registration
                  input(type="number", min="1", v-model="localValue.minimum_driver_registration_seniority" placeholder="Years of registration")
              .column
                label Driver age
                  input(type="number", min="1", v-model="localValue.minimum_driver_age")
            label Client minimum invoiced
              input(type="number", min="1", v-model="localValue.minimum_client_invoiced")
            label Minimum document emission years
              input(type="number", min="1", v-model="localValue.minimum_document_emission_years")
              .help-text
                small Overrides global configuration

</template>
<script type="text/babel">

import SelectizeDocumentType from "../ui/lists/selectize/SelectizeDocumentType.vue";
import BaseForm from "./BaseForm.vue";

export default {
  name: 'DocumentRequirementForm',
  extends: BaseForm,
  components: {SelectizeDocumentType},
  data() {
    return {

    }
  },
  created() {
  },
  methods: {
    documentTypeSelected(obj) {
      //this.body.document_types.push(obj.id)
      this.localValue.document_type_id = obj.id
    },  },
  props: ['value']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DocumentRequirementForm.vue?e9c869fc